/**
 * Your Store Cart — assets/site-cart.js
 * "You may also like" recommendations carousel.
 * Loaded with `defer` from main-cart-items.liquid and cart-recommendations.liquid.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initRecsCarousel() {
    const root = document.querySelector('[data-pc-recs]');
    if (!root) return;

    const productId = root.dataset.productId;
    const limit = parseInt(root.dataset.limit, 10) || 8;
    const intent = root.dataset.intent || 'related';
    const track = root.querySelector('[data-pc-recs-track]');
    const prevBtn = root.querySelector('.pc-recs__arrow--prev');
    const nextBtn = root.querySelector('.pc-recs__arrow--next');
    const dotsHost = root.querySelector('[data-pc-recs-dots]');
    if (!track || !productId) return;

    const jsonUrl = '/recommendations/products.json?product_id=' + encodeURIComponent(productId)
      + '&limit=' + encodeURIComponent(limit)
      + '&intent=' + encodeURIComponent(intent);

    fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.products || data.products.length === 0) {
          root.style.display = 'none';
          return;
        }
        renderCards(data.products);
        initCarousel();
      })
      .catch(function (err) {
        console.error('[pc-cart] recommendations fetch failed', err);
        root.style.display = 'none';
      });

    function renderCards(products) {
      track.innerHTML = '';
      products.forEach(function (p) {
        const card = document.createElement('a');
        card.className = 'pc-recs__card';
        card.href = p.url;
        const img = p.featured_image
          ? '<div class="pc-recs__image-wrap"><img class="pc-recs__image" src="' + escapeAttr(p.featured_image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="400" height="400"></div>'
          : '<div class="pc-recs__image-wrap"><div class="pc-recs__image pc-recs__image--placeholder"></div></div>';
        card.innerHTML = img
          + '<h3 class="pc-recs__title">' + escapeHtml(p.title) + '</h3>'
          + '<p class="pc-recs__price">' + formatPrice(p.price) + '</p>';
        track.appendChild(card);
      });
    }

    function initCarousel() {
      const cards = track.querySelectorAll('.pc-recs__card');
      if (cards.length === 0) return;

      function getCardsPerView() {
        const w = window.innerWidth;
        if (w < 750) return 2;
        if (w < 992) return 3;
        return 4;
      }

      function getCardWidth() {
        if (cards.length < 2) return cards[0].offsetWidth;
        return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      }

      function rebuildDots() {
        if (!dotsHost) return;
        dotsHost.innerHTML = '';
        const cardsPerView = getCardsPerView();
        const totalPages = Math.max(1, Math.ceil(cards.length / cardsPerView));
        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.className = 'pc-recs__dot';
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          if (i === 0) dot.setAttribute('aria-current', 'true');
          (function (idx) {
            dot.addEventListener('click', function () {
              const targetCard = cards[idx * cardsPerView];
              if (targetCard) {
                track.scrollTo({ left: targetCard.offsetLeft - track.offsetLeft, behavior: 'smooth' });
              }
            });
          })(i);
          dotsHost.appendChild(dot);
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
        });
      }

      function updateState() {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

        if (!dotsHost) return;
        const cardWidth = getCardWidth();
        if (cardWidth <= 0) return;
        const cardsPerView = getCardsPerView();
        const activeIdx = Math.round(track.scrollLeft / cardWidth / cardsPerView);
        const dots = dotsHost.children;
        for (let i = 0; i < dots.length; i++) {
          if (i === activeIdx) dots[i].setAttribute('aria-current', 'true');
          else dots[i].removeAttribute('aria-current');
        }
      }

      let rafId = null;
      track.addEventListener('scroll', function () {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateState);
      });

      let resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          rebuildDots();
          updateState();
        }, 150);
      });

      rebuildDots();
      updateState();
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escapeAttr(s) { return escapeHtml(s); }
    function formatPrice(cents) {
      const value = (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + value;
    }
  }

  ready(initRecsCarousel);
})();
